import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Axios from 'axios';
let instance = Axios.create({
  timeout: 30000,
  withCredentials: false,
  maxContentLength: 128 * 1024 * 1024
});
instance.setData = (token, baseURL, headers) => {
  instance.defaults.headers = _objectSpread(_objectSpread({}, instance.defaults.headers), headers);
  instance.defaults.headers.common.Authorization = `Bearer ${token}`;
  instance.defaults.baseURL = baseURL;
};
instance.setInstance = axiosInstance => {
  // Soft copy
  Object.keys(axiosInstance).forEach(key => instance[key] = axiosInstance[key]);
};
export default instance;